import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import ConfirmDialog from 'components/Dialog/Confirm';
import WorkingModal from './WorkingModal';
import {
  fetchAdjustmentTypeList,
  tryUpdateAdjustmentTypeName,
  tryAddAdjustmentType,
  tryDeleteAdjustmentType
} from 'actions/SalaryActions.js';
import {getURL} from '../../routes';

class AdjustmentPanel extends Component {
  state = {
    mode: 'OFF',
    selectedID: 0
  }

  dismiss = () => {
    this.setState({mode: 'OFF'})
  }

  activeAdd = () => {
    this.setState({mode: 'ADD', selectedID: 0})
  }

  activeEdit = (id) => {
    return () => this.setState({mode: 'EDIT', selectedID: id})
  }

  componentDidMount() {
    this.props.dispatch(fetchAdjustmentTypeList());
  }

  handleDelete = (id, name) => {
    return () => {
      ConfirmDialog(`確認是否删除${name}`)
        .then(
          () => {
            this.props.dispatch(tryDeleteAdjustmentType(id))
          },
          () => {}
        )
    }
  }

  handleAdd = (name) => {
    this.props.dispatch(tryAddAdjustmentType(name));
    this.dismiss();
  }

  handleEdit = (id) => {
    return (name) => {
      this.props.dispatch(tryUpdateAdjustmentTypeName(id, name))
      this.dismiss();
    }
  }

  buildAdjustmentTypeRow = (typeList) => {
    return typeList.map((type) => {
      let id = type.get('id');
      let name = type.get('name');

      return (
        <tr key={id}>
          <th>
            {name}
          </th>
          <th>
            <button
              className="btn btn-default"
              onClick={this.activeEdit(id)}>
              <span className="glyphicon glyphicon-pencil"/>
            </button>
            {" "}
            <button
              className="btn btn-danger"
              onClick={this.handleDelete(id, name)}>
              <span className="glyphicon glyphicon-trash" />
            </button>
          </th>
        </tr>
      )
    })
  }

  render() {
    let {typeList, dispatch} = this.props;
    let {mode, selectedID} = this.state;
    return (
      <div className="company setting-panel">
        <div className="setting-header">
          <button
            className="btn btn-default"
            onClick={()=>{dispatch(push(getURL('/ws-admin/setting')))}}>
            返回
          </button>
          <button
            className="btn btn-primary pull-right"
            onClick={this.activeAdd}>
            新增
          </button>
        </div>
        <div className="setting-content">
          {(typeList.size > 0 ?
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th className="name">
                      名稱
                    </th>
                    <th className="action">
                      動作
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {typeList.size > 0 && this.buildAdjustmentTypeRow(typeList)}
                </tbody>
              </table>
            :
              <div className="alert-heading">沒有任何記錄</div>
          )}
        </div>
        {(mode === 'ADD' || mode === 'EDIT') &&
          <WorkingModal
            action={(selectedID > 0? this.handleEdit(selectedID) : this.handleAdd)}
            dismiss={this.dismiss}
            mode={mode}
            id={selectedID}
            name={(selectedID > 0 ? typeList.get(typeList.findIndex((type) => type.get('id') === selectedID)).get('name') : "")}
            />}
      </div>
    )
  }
}

export default connect((state) => ({
  typeList: state.salary.get('adjustmentTypeList')
}))(AdjustmentPanel);



// WEBPACK FOOTER //
// ./src/components/Setting/AdjustmentPanel.js